import { getPaywallType } from "src/appConfig";

import { Paywall as QuizPaywall } from "./quiz/1.0";
import { Paywall as WalkyPaywall } from "./walky/1.0";
import { Paywall as WalkyPaywall_v2 } from "./walky/2.0";
import { Paywall as QuizPaywall_v2 } from "./quiz/2.0";
import { Paywall as DefaultPaywall } from "./default/1.0";
import { SomaticPaywall } from "./somatic/1.0";

const PAYWALL_VARIANTS = {
  DEFAULT_PAYWALL: DefaultPaywall,
  QUIZ_PAYWALL: QuizPaywall,
  WALKY_PAYWALL_V1: WalkyPaywall,
  WALKY_PAYWALL_V2: WalkyPaywall_v2,
  QUIZ_PAYWALL_V2: QuizPaywall_v2,
  SOMATIC_PAYWALL: SomaticPaywall,
};

export const Paywall = () => {
  const paywallType = getPaywallType();

  const CurrentPaywall = PAYWALL_VARIANTS[paywallType] || DefaultPaywall;

  return <CurrentPaywall />;
};
